interface LogoProps {
  className?: string;
  showWordmark?: boolean;
  size?: number;
  /** When true, renders a simplified inverted version on dark backgrounds */
  inverse?: boolean;
}

/**
 * ParkConfetti logo: a stylized "P" mark with confetti pieces flying off,
 * paired with the wordmark. The mark works alone (favicon, app icon) and
 * with the wordmark (nav, footer).
 */
export default function Logo({
  className = '',
  showWordmark = true,
  size = 36,
  inverse = false,
}: LogoProps) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        aria-hidden="true"
        className="flex-shrink-0"
      >
        <defs>
          <linearGradient id="pc-logo-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FF3D7F" />
            <stop offset="100%" stopColor="#FF7A59" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="url(#pc-logo-bg)" />
        <path
          d="M22 16 h11 a10 10 0 0 1 0 20 h-5 v12 h-6 z M28 22 v8 h5 a4 4 0 0 0 0 -8 z"
          fill="#FFFBF5"
        />
        <rect x="42" y="14" width="5" height="3" rx="1" transform="rotate(20 44.5 15.5)" fill="#FFD93D" />
        <rect x="46" y="22" width="4" height="3" rx="1" transform="rotate(-30 48 23.5)" fill="#A8E060" />
        <rect x="40" y="34" width="5" height="3" rx="1" transform="rotate(45 42.5 35.5)" fill="#3D7FFF" />
        <circle cx="50" cy="42" r="2" fill="#FFD93D" />
        <circle cx="14" cy="46" r="1.7" fill="#3D7FFF" />
        <rect x="44" y="48" width="4" height="3" rx="1" transform="rotate(-15 46 49.5)" fill="#A8E060" />
      </svg>
      {showWordmark && (
        <span
          className={`font-display font-bold text-xl tracking-tight ${
            inverse ? 'text-cream-50' : 'text-ink-900'
          }`}
        >
          park<span className="text-confetti-pink">confetti</span>
        </span>
      )}
    </div>
  );
}
